import { trendingProducts } from "@/mocks/categories";

export default function TrendingSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            Trending Now
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Popular items flying off the <strong>acbuyspreadsheet</strong> shelves this week
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trendingProducts.map((product) => (
            <a
              key={product.name}
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200"
            >
              <div className="relative">
                {product.tag && (
                  <span className="absolute top-3 left-3 z-10 px-3 py-1 rounded-full text-xs font-semibold bg-accent-500 text-background-50">
                    {product.tag}
                  </span>
                )}
                <div className="aspect-square overflow-hidden bg-background-100">
                  <img
                    src={product.imageUrl}
                    alt={`${product.name} - acbuyspreadsheet trending`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="p-4 text-center">
                <p className="text-xs text-foreground-500 mb-1">{product.category}</p>
                <h3 className="font-semibold font-heading text-foreground-900 mb-1">
                  {product.name}
                </h3>
                <p className="text-sm font-bold text-primary-600">{product.price}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}